interface Props {
  label: string;
  value: string | number;
  note?: string;
  /** Отформатировать число с локализацией ('ru-RU'). По дефолту — да. */
  format?: boolean;
}

/**
 * Карточка с числовой статистикой (используется в Dashboard, на главной,
 * в админ-панели). Локализует число пробелами как разделителями
 * (`1 234 567`) для русского формата.
 */
export function Stat({ label, value, note, format = true }: Props) {
  const display = (() => {
    if (!format) return String(value);
    const n = typeof value === 'string' ? Number(value) : value;
    if (!Number.isFinite(n)) return String(value);
    return n.toLocaleString('ru-RU');
  })();

  return (
    <div className="stat">
      <div className="stat-value">{display}</div>
      <div className="stat-label">{label}</div>
      {note && <div className="stat-note">{note}</div>}
    </div>
  );
}
